import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [

        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconComponent: FeatherIcons.GridIcon,
            group: 'general',
        },
        {
            name: 'Content',
            children: [
                // { name: 'Layouts', route: 'layouts', shortcut: 'layout/_' },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
            ],
            iconComponent: FeatherIcons.LayersIcon,
            group: 'general',
        },
        {
            name: 'Assets',
            children: [
                { name: 'Assets', route: 'assets', type: 'asset' },
            ],
            iconComponent: FeatherIcons.ImageIcon,
            group: 'general',
        },

        {
            name: 'LGS Framing',
            route: 'lgs_framing',
            type: 'lgs_framing',
            iconComponent: FeatherIcons.HomeIcon,
            group: 'general',
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'Applications', route: 'applications', type: 'application' },
                { name: 'Connectors', route: 'connectors', type: 'connector' },
            ],
            iconComponent: FeatherIcons.BoxIcon,
            group: 'catalogue',
        },
       /*  {
            name: 'Software',
            route: 'software',
            type: 'software',
            iconComponent: FeatherIcons.CpuIcon,
            group: 'catalogue',
        }, */
        {
            name: 'Resources',
            children: [
                { name: 'Resources', route: 'resources', type: 'resource' },
                { name: 'Categories', route: 'resource_categories', type: 'resource_category' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'FAQs',
            route: 'faqs',
            type: 'faq',
            iconComponent: FeatherIcons.MessageCircleIcon,
            group: 'media',
            color: 'navy',
        },
        {
            name: 'Gallery',
            children: [
                { name: 'Gallery', route: 'gallery', type: 'gallery' },
                { name: 'Categories', route: 'gallery_categories', type: 'gallery_category' },
            ],
            iconComponent: FeatherIcons.CameraIcon,
            group: 'media',
        },
        // {
        //     name: 'Videos',
        //     route: 'videos',
        //     type: 'video',
        //     iconComponent: FeatherIcons.VideoIcon,
        //     group: 'media',
        // },
        {
            name: 'Showcases',
            route: 'case_studies',
            type: 'case_study',
            iconComponent: FeatherIcons.BookOpenIcon,
            group: 'media',
        },
        /* {
            name: 'Stories',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            iconComponent: FeatherIcons.FileTextIcon,
            group: 'media',
        }, */
       /*  {
            name: 'Events',
            route: 'event',
            type: 'event',
            iconComponent: FeatherIcons.CalendarIcon,
            group: 'media'
        }, */
        {
            name: 'Customers',
            type: 'customer',
            route: 'customers',
            iconComponent: FeatherIcons.UsersIcon,
            group: 'customers',
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
                { name: 'Downloads', route: 'downloads', type: 'download' },
                { name: 'Payments', route: 'payments', type: 'payment' },
            ],
            iconComponent: FeatherIcons.MessageSquareIcon,
            group: 'customers',
        },
        {
            name: 'Search Logs',
            route: 'search_logs',
            type: 'search_log',
            iconComponent: FeatherIcons.SearchIcon,
            group: 'customers',
        },
        {
            name: 'Testimonials',
            route: 'testimonials',
            type: 'testimonial',
            iconComponent: FeatherIcons.StarIcon,
            group: 'customers',
        },
        {
            name: 'Staff',
            children: [
                { name: 'Staff Members', type: 'staff_member', route: 'staff_members' },
                { name: 'Departments', type: 'department', route: 'departments' },
            ],
            iconComponent: FeatherIcons.UsersIcon,
            group: 'company',
        },
        {
            name: 'Careers',
            type: 'career',
            route: 'careers',
            iconComponent: FeatherIcons.BriefcaseIcon,
            group: 'company',
        },
        {
            name: 'Branches',
            route: 'branchs',
            type: 'branch',
            iconComponent: FeatherIcons.MapIcon,
            group: 'company',
        },
        {
            name: 'Partners',
            route: 'partners',
            type: 'partner',
            iconComponent: FeatherIcons.GridIcon,
            group: 'company',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
                { name: 'Activities', route: 'user_logins', type: 'user_login' },
            ],
            iconComponent: FeatherIcons.LockIcon,
            group: 'settings',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Maintenance', route: 'setting/1#maintenance', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconComponent: FeatherIcons.SettingsIcon,
            group: 'settings',
        }
    ],
    defaultItem: 'Content',
}
